<div
  *ngrxLet="installationDetailsStore.getSelectedDashboardTypeHelper$ as dashboardType"
  class="tiles flex flex-row gap-[8px]"
>
  <!-- Common devices / eco water -->
  <app-device-tile-wrapper
    *ngFor="
      let device of devicesStore.mainDevicesForHeaderTiles$ | async;
      trackBy: mainDevicesTrackBy
    "
    gtm="onSelectDevice"
    gtmAction="Installation Details"
    gtmCategory="gatewayDevices"
    [device]="device"
    [class.tile-active]="
      device.isSelected &&
      (dashboardType === DashboardTypes.DEFAULT || dashboardType === DashboardTypes.SOLARLOG)
    "
    class="tile flex flex-row"
    data-at-device-tile
    (click)="selectMainDevice(device)"
  >
  </app-device-tile-wrapper>

  <!-- Dry contact device -->
  <div
    data-at-dry-contacts-tab
    *ngIf="devicesStore.dryContactHeatPump$ | async as device"
    gtm="onSelectDevice"
    gtmAction="Dry Contacts Installation Details"
    gtmCategory="gatewayDevices"
    [class.tile-active]="device.isSelected && dashboardType === DashboardTypes.DRY_CONTACT"
    class="tile flex flex-col"
    (click)="openDryContactDevice(device)"
  >
    <app-dry-contact-devices-header-tile [device]="device"> </app-dry-contact-devices-header-tile>
  </div>

  <!-- Dry contact generic consumers -->
  <div
    data-at-dry-contacts-generic-consumer-tab
    *ngFor="let device of devicesStore.dryContactGeneric$ | async; trackBy: mainDevicesTrackBy"
    gtm="onSelectDevice"
    gtmAction="Installation Details"
    gtmCategory="gatewayDevices"
    [class.tile-active]="
      device.isSelected && dashboardType === DashboardTypes.DRY_CONTACT_GENERIC_CONSUMER
    "
    class="tile flex flex-col"
    (click)="openDryContactGenericConsumerDevice(device)"
  >
    <app-dry-contact-devices-header-tile [device]="device"> </app-dry-contact-devices-header-tile>
  </div>

  <!-- No devices case -->
  <ng-container
    *ngIf="!(this.installationDetailsStore.selectGatewayHasDevices(gatewaySerial) | async)"
  >
    <div class="tile tile-active flex flex-col justify-between items-start">
      <div class="flex flex-row">
        <div class="device-img-wrapper">
          <img src="/assets/img/devices/standalone.png" class="device-img" />
        </div>
        <div class="flex flex-col justify-between items-start">
          <span class="tile-title">
            {{ '+INSTALLATIONS.INSTALLATION.GATEWAY.TITLE' | translate }}
          </span>
          <span>{{ gatewaySerial }} </span>
        </div>
      </div>
      <app-aggregated-status-pill [gatewaySerial]="gatewaySerial"></app-aggregated-status-pill>
    </div>
  </ng-container>

  <!-- Wallbox -->
  <ng-container *ngFor="let wallboxDevice of wallboxDevices$ | async">
    <app-obng-wallbox-tile
      *ngIf="wallboxDevice | isObngWallbox; else e3Wallbox"
      [device]="wallboxDevice"
      [gatewaySerial]="gatewaySerial"
      data-at-wallbox-tile
      gtm="onOpen"
      gtmAction="Installation Details"
      gtmCategory="wallbox"
      class="tile"
      [class.tile-active]="
        (uiService.idOfOpenedWallboxDevice$ | async) === wallboxDevice.wallboxIndex
      "
      (click)="openWallbox(wallboxDevice)"
    ></app-obng-wallbox-tile>
    <ng-template #e3Wallbox>
      <app-e3-wallbox-tile
        [device]="wallboxDevice"
        [gatewaySerial]="gatewaySerial"
        data-at-wallbox-tile
        gtm="onOpen"
        gtmAction="Installation Details"
        gtmCategory="wallbox"
        class="tile"
        [class.tile-active]="
          (uiService.idOfOpenedWallboxDevice$ | async) === wallboxDevice.wallboxIndex
        "
        (click)="openWallbox(wallboxDevice)"
      ></app-e3-wallbox-tile>
    </ng-template>
  </ng-container>

  <!-- PV Immersion Heater -->

  <ng-container
    *ngIf="devicesStore.selectAllSolarLogPvImmersionHeater() | async as pvHeaterDevices"
  >
    <div
      *ngFor="let device of pvHeaterDevices"
      data-at-pv-immersion-tab
      gtm="onOpen"
      gtmAction="Installation Details"
      gtmCategory="PV immersion heater"
      class="tile flex flex-col"
      [class.tile-active]="dashboardType === DashboardTypes.PV_IMMERSION_HEATER"
      (click)="openPvImmersionHeater(device)"
    >
      <span
        class="tile-title"
        *ngIf="
          (getDeviceThirdpartyModelFeature(device.id, device.gatewaySerial) | async | ready)
            ?.properties?.value?.value as deviceThirdpartyModel;
          else defaultPVTitle
        "
      >
        {{ deviceThirdpartyModel }}
      </span>
      <ng-template #defaultPVTitle>
        <span class="tile-title">
          {{ '+INSTALLATIONS.INSTALLATION.PV_HEATER.DETAILS.TITLE' | translate }}
        </span>
      </ng-template>

      <div
        *ngIf="
          (getDeviceEtnFeature(device.id, device.gatewaySerial) | async | ready)?.properties?.value
            ?.value as deviceEtn
        "
        class="serial-container"
      >
        <span class="serial">
          {{ deviceEtn }}
        </span>
      </div>
    </div>
  </ng-container>
  <!-- HEMS -->
  <div
    data-at-hems-tab
    *ngIf="
      (installationFeaturesStore.selectHemsFeaturesPresent$ | async) ||
      (devicesStore.isE3HeatpumpDevice() | async) ||
      isAnyDeviceWithVitochargeRole
    "
    gtm="onOpen"
    gtmAction="Installation Details"
    gtmCategory="hems"
    [class.tile-active]="dashboardType === DashboardTypes.HEMS"
    class="tile flex flex-col"
    (click)="openHems()"
  >
    <span class="tile-title">{{ '+HEMS.HEMS_TITLE' | translate }}</span>
  </div>
</div>
